import { SocialUploadStatus } from '@app/modules/fragments/screens/view/components/export/social-export/SocialUploadStatus';
import { SocialPlatformCard } from '@app/modules/social-export/components/common/SocialPlatformCard';
import {
  FacebookPlatform,
  socialPlatforms,
  YoutubePlatform,
} from '@app/modules/social-export/domain/platforms';
import { ContentDto, SocialVersionDto } from '@app/modules/content-ai/content-ai.types';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ContentBadge, ContentBody, ContentTitle } from '../../components';

export function SocialVersionPublished({
  content,
  version,
}: {
  content: ContentDto;
  version: SocialVersionDto;
}) {
  if (!version.uploadId) {
    return null;
  }

  const platform = socialPlatforms.get(version.platform);
  const hasTitle =
    version.platform === YoutubePlatform.id || version.platform === FacebookPlatform.id;

  return (
    <SocialPlatformCard platform={platform}>
      <Box>
        {/* Badge */}
        <Box sx={{ mb: 2 }}>
          <ContentBadge
            icon={platform.Icon({
              sx: { width: 16, height: 16, color: '#AF52DE' },
            })}
          >
            <FormattedMessage
              id="contentAi.socialVersion.generatedFor"
              defaultMessage="Contenido generado para {platform}"
              values={{ platform: platform.name }}
            />
          </ContentBadge>
        </Box>

        {/* Title (if applicable) */}
        {hasTitle && <ContentTitle sx={{ mb: 2 }}>{version.userConfig?.title}</ContentTitle>}

        {/* Status Button and Link */}
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            mb: 3,
            alignItems: 'flex-start',
            flexDirection: 'column',
          }}
        >
          {/* <Button
            variant="contained"
            disabled
            sx={{
              padding: '8px 16px',
              backgroundColor: '#99EFD5',
              borderRadius: '6px',
              color: 'text.primary',
              fontSize: '16px',
              fontFamily: 'Inter',
              fontWeight: 500,
              lineHeight: '28px',
              textTransform: 'none',
              '&.Mui-disabled': {
                backgroundColor: '#99EFD5',
                color: 'text.primary',
              },
            }}
          >
            Contenido publicado
          </Button> */}

          <Box>
            {/* Upload status component inline */}
            <SocialUploadStatus id={version.uploadId} />
          </Box>
        </Box>

        {/* Collapsible Body */}
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box component="span">
              <FormattedMessage
                id="contentAi.viewFullArticle"
                defaultMessage="Ver artículo completo"
              />
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <ContentBody>{version.userConfig?.body}</ContentBody>
          </AccordionDetails>
        </Accordion>
      </Box>
    </SocialPlatformCard>
  );
}
